// extracted by mini-css-extract-plugin
export default {"formControl":"formControl--uoA8t","invalid":"invalid--lRGuX","big":"big--h9SCv","arrows":"arrows--Qi9hZ"};